/**
 * Dil kodu (en/tr/ru…) → backend locale id (locales.id) — tek kaynak.
 *
 * Backend içerik dilini locale id ile seçer (body `language` ya da `Clientlanguage` header;
 * ikisi de yoksa marka varsayılanı — RU proxy'de TR'nin varsayılanı = English).
 * InitApp'ten gelen `language` satırları (Apps.language) varsa onlar esas alınır;
 * gelmediyse sabit harita (locales tablosundaki id'ler) kullanılır.
 */
import { getLang, isLangReady } from './dict';

const STATIC_IDS = { en: 2, ru: 3, de: 4, tr: 5, es: 7, fr: 8, it: 9 };

let dynamicIds = {};

/** InitApp `language` satırlarından (id + lang) haritayı tazeler. */
export const setLocaleRows = (rows) => {
    const next = {};
    (Array.isArray(rows) ? rows : []).forEach((l) => {
        const code = l && l.lang ? String(l.lang).slice(0, 2).toLowerCase() : '';
        const id = l ? Number(l.id !== undefined ? l.id : l.value) : 0;
        if (code && id > 0 && !next[code]) next[code] = id;
    });
    dynamicIds = next;
};

/** Dil kodu → locale id; bilinmiyorsa null. */
export const localeIdOf = (code) => {
    const c = String(code || '').slice(0, 2).toLowerCase();
    if (!c) return null;
    return dynamicIds[c] || STATIC_IDS[c] || null;
};

/** Ekranda GERÇEKTEN görünen UI dilinin locale id'si; I18nProvider henüz dil uygulamadıysa null. */
export const currentLocaleId = () => (isLangReady() ? localeIdOf(getLang()) : null);

// Yalnız içerik dili okuyan katalog uçları (MakeBooking/*, ProductView/*). BookingCalculate
// bilerek DIŞARIDA: orada dil yoksa ürün diline düşülüyor (davranış korunur).
const LANG_AWARE = /^\/?(MakeBooking|ProductView)\//i;

/** Axios interceptor yardımcısı: katalog isteklerine `Clientlanguage` header'ı ekler.
 *  Body'deki açık `language` backend'de yine önceliklidir. */
export const applyClientLanguage = (config) => {
    try {
        if (!config || !LANG_AWARE.test(String(config.url || ''))) return config;
        const id = currentLocaleId();
        if (id && config.headers && !config.headers['Clientlanguage']) {
            config.headers['Clientlanguage'] = String(id);
        }
    } catch (e) { /* header opsiyonel */ }
    return config;
};
